import { type ExternalMessageLoader, isLocaleSupported } from '@canvas/intl';
import type { SupportedLocale } from '@canvas/intl-types';

import {
  ConversationAssistantMessagesMap,
  DatasourceMessagesMap,
  smartCardMessagesMap
} from './external-messages.ts';
import { pickExternalMessages } from './utils.ts';

enum DatabasesExternalMessage {
  SMART_CARD = 'smart-card',
  DATASOURCES = 'link-datasource',
  CONVERSATION_ASSISTANT = 'conversation-assistant'
}
/**
 * Define a map of each locale and its loaders for external dependencies. We must do it this way
 * as Vite needs to know the dependencies at build time, so we cannot dynamically construct
 * the import paths
 */
export const externalMessagesMap: Record<
  SupportedLocale,
  Record<DatabasesExternalMessage, ExternalMessageLoader[]>
> = pickExternalMessages(
  {
    name: DatabasesExternalMessage.SMART_CARD,
    map: smartCardMessagesMap
  },
  {
    name: DatabasesExternalMessage.DATASOURCES,
    map: DatasourceMessagesMap
  },
  {
    name: DatabasesExternalMessage.CONVERSATION_ASSISTANT,
    map: ConversationAssistantMessagesMap
  }
);

export function getExternalDatabasesMessages(
  userLocale: string
): Record<DatabasesExternalMessage, ExternalMessageLoader[]> {
  const locale: SupportedLocale = isLocaleSupported(userLocale) ? userLocale : 'en';

  return externalMessagesMap[locale];
}
